"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./environment-detection"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/utils/index.js
// module id = 1523
// module chunks = 0 1 2 3